module.exports = __webpack_public_path__ + "static/media/travel-guru.fd61bf83.jpg";